module.exports = __webpack_public_path__ + "static/media/Barterer.11baf3b0.png";